import $ from "jquery";
import {GPProjectView} from "./gp-projectview.js";
import {writable} from "svelte/store";
import {mode, magic} from "./gp.js";

export const modeStore = writable('optionBrush');
export const sizeStore = writable('optionBrush2');
export const somethingDrawn = writable(false);

export let GPContextInpainting = {
    inpaintingLayer: null, // On this we draw and also display cursor.
    inpaintingCanvas: null,
    inpaintingImage: null,
    brushMode: null,
    brushSize: null,
    brushSizes: {'optionBrush1': 15, 'optionBrush2': 30, 'optionBrush3': 50},
    inpaintingCursor: null,
    inpaintingCursorLastPos: null,
    inpaintingContext: null, //js 2d drawing context
    storesInitiated: false,
    projectView: null,

    init: function (projectView) {
        GPContextInpainting.projectView = projectView;

        if (!GPContextInpainting.storesInitiated) {
            modeStore.subscribe((s) => {GPContextInpainting.brushMode = s; GPContextInpainting.updateinpaintingCursorMode()});
            sizeStore.subscribe((s) => {GPContextInpainting.brushSize = s; GPContextInpainting.updateinpaintingCursorMode()});

            mode.subscribe((m) => {
                if (m === "Inpainting" && !GPContextInpainting.inpaintingLayer)
                    GPContextInpainting.activate();
                if (m !== "Inpainting" && GPContextInpainting.inpaintingLayer)
                    GPContextInpainting.deactivate()
            })
            GPContextInpainting.storesInitiated = true;
        }
    },

    activate: function(id) {
        $(document).off("keydown", GPContextInpainting.handleKeyboard).on("keydown", GPContextInpainting.handleKeyboard);

        GPContextInpainting.inpaintingLayer = new Konva.Layer();
        GPContextInpainting.inpaintingLayer.opacity(0.5);
        GPContextInpainting.projectView.stage.add(GPContextInpainting.inpaintingLayer);
        GPContextInpainting.createInpaitingImage();

        GPContextInpainting.inpaintingCursor = new Konva.Circle({
            x: 100,
            y: 100,
            radius: 30,
            stroke: 'white',
            strokeWidth: 1
          }).visible(false);
        GPContextInpainting.inpaintingLayer.add(GPContextInpainting.inpaintingCursor);

        GPContextInpainting.inpaintingLayer.on("mouseenter", GPContextInpainting.activateCursor);
        GPContextInpainting.inpaintingLayer.on("mouseleave", GPContextInpainting.disableinpaintingCursor);
        GPContextInpainting.inpaintingLayer.on('mousemove',GPContextInpainting.moveinpaintingCursorHandler);

        GPContextInpainting.resetCutter();
        GPContextInpainting.setupinpaintingCursor();
    },

    createInpaitingImage: function() {
        GPContextInpainting.inpaintingCanvas = document.createElement('canvas');
        GPContextInpainting.inpaintingCanvas.width = GP.project.sizeX;
        GPContextInpainting.inpaintingCanvas.height = GP.project.sizeY;
        GPContextInpainting.inpaintingImage = new Konva.Image({
            x: 0,
            y: 0,
            id: "inpainting",
            image: GPContextInpainting.inpaintingCanvas
        });
        GPContextInpainting.inpaintingLayer.add(GPContextInpainting.inpaintingImage);

        GPContextInpainting.inpaintingImage.width(GPProjectView.width);
        GPContextInpainting.inpaintingImage.height(GPProjectView.height);
    },


    deactivate: function() {
        $(document).off("keydown", GPContextInpainting.handleKeyboard);
        GPContextInpainting.disableinpaintingCursor();
        GPContextInpainting.inpaintingLayer.destroy();
        GPContextInpainting.inpaintingLayer = null;
    },

    onresize: function () {
        if (GPContextInpainting.inpaintingImage) {
            GPContextInpainting.inpaintingImage.width(GPProjectView.width);
            GPContextInpainting.inpaintingImage.height(GPProjectView.height);
        }
    GPContextInpainting.updateinpaintingCursorMode()
    },


    resetCutter: function () {
        var isPaint = false;

        // now we need to bind some events
        // we need to start drawing on mousedown
        // and stop drawing on mouseup
        GPContextInpainting.inpaintingLayer.off('touchstart mousedown').on('touchstart mousedown', function (event) {
            isPaint = true;
            GPContextInpainting.inpaintingCursorLastPos = GPProjectView.getPointerPosition(event);
        });

        GPContextInpainting.inpaintingLayer.off('touchend mouseup').on('touchend mouseup', function () {
            isPaint = false;
        });

        //if we're incidentaly leave drawing area and return later - start line at
        //the new entry point
        function updateCursorPos(event) {
            GPContextInpainting.inpaintingCursorLastPos = GPProjectView.getPointerPosition(event);
            if (event.evt.buttons !== 1) isPaint = false;
        }
        GPContextInpainting.inpaintingLayer.off('mouseenter', updateCursorPos).on('mouseenter', updateCursorPos);

        // and core function - drawing
        function doCutFunc (event) {
            if (!isPaint)
                return;

            var lastLocalPos = {
                x: GPContextInpainting.inpaintingCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextInpainting.inpaintingCursorLastPos.y / GPProjectView.sceneScale
            };

            var pos = GPProjectView.getPointerPosition(event);

            var localPos = {
                x: pos.x / GPProjectView.sceneScale,
                y: pos.y / GPProjectView.sceneScale
            };

            GPContextInpainting.doCut(lastLocalPos, localPos);

            GPContextInpainting.inpaintingCursorLastPos = pos;
        }
        GPContextInpainting.inpaintingLayer.off('touchmove mousemove', doCutFunc).on('touchmove mousemove', doCutFunc);

        // Good. Now we need to get access to GPProjectView.inpaintingContext element
        GPContextInpainting.inpaintingContext = GPContextInpainting.inpaintingImage.getImage().getContext('2d');
        GPContextInpainting.inpaintingContext.lineJoin = "round";
        GPContextInpainting.inpaintingContext.lineCap = "round";
        GPContextInpainting.inpaintingContext.lineWidth = GPContextInpainting.brushSize * GP.project.sizeX / 1024;

        GPContextInpainting.inpaintingContext.strokeStyle = "#000000";

        GPContextInpainting.updateinpaintingCursorMode();
    },

    doCut: function(from, to) {

        if (GPContextInpainting.brushMode === "optionBrush") {
            GPContextInpainting.inpaintingContext.globalCompositeOperation = 'source-over';
            somethingDrawn.set(true);
        }
        if (GPContextInpainting.brushMode === "optionEraser") {
            GPContextInpainting.inpaintingContext.globalCompositeOperation = 'destination-out';
        }

        GPContextInpainting.inpaintingContext.beginPath();
        GPContextInpainting.inpaintingContext.moveTo(from.x, from.y);
        GPContextInpainting.inpaintingContext.lineTo(to.x, to.y);
        GPContextInpainting.inpaintingContext.lineWidth = GPContextInpainting.brushSize * GP.project.sizeX / 1024;
        GPContextInpainting.inpaintingContext.stroke();

        GPContextInpainting.inpaintingLayer.draw();
    },

    moveinpaintingCursor: function(pos) {
        GPContextInpainting.inpaintingCursor.setX(pos.x);
        GPContextInpainting.inpaintingCursor.setY(pos.y);
    },

    moveinpaintingCursorHandler: function(e) {
        var pos = GPProjectView.getPointerPosition(e);
        GPContextInpainting.moveinpaintingCursor(pos);
    },

    updateinpaintingCursorMode: function() {
        if (!GPContextInpainting.inpaintingLayer) return;

        var size = GPContextInpainting.brushSizes[GPContextInpainting.brushSize];
        GPContextInpainting.inpaintingCursor.setRadius(size/2 * GPProjectView.width / 1024);
        if (GPContextInpainting.inpaintingContext) GPContextInpainting.inpaintingContext.lineWidth = size * GP.project.sizeX / 1024;
    },

    setupinpaintingCursor: function() {
        if (!GPContextInpainting.inpaintingCursorLastPos)
            GPContextInpainting.inpaintingCursorLastPos = {
                x: $('#GPProjectView').innerWidth() / 2,
                y: $('#GPProjectView').innerHeight() * 0.8
            };
        GPContextInpainting.updateinpaintingCursorMode();
        GPContextInpainting.inpaintingCursor.setZIndex(1);
        GPContextInpainting.moveinpaintingCursor(GPContextInpainting.inpaintingCursorLastPos);
        GPContextInpainting.activateCursor();
    },

    disableinpaintingCursor: function() {
        GPContextInpainting.inpaintingCursor.visible(false);
    },

    activateCursor: function() {
        GPContextInpainting.inpaintingCursor.visible(true);
    },

    inpaintObjects: function() {
        magic.set(true);
        GP.showWaiting();
        var can = document.createElement('canvas');

        can.width = GP.project.sizeX * GPProjectView.sceneScale;
        can.height = GP.project.sizeY * GPProjectView.sceneScale;
        var ctx = can.getContext('2d');
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, can.width, can.height);

        GPContextInpainting.inpaintingLayer.opacity(1);
        ctx.drawImage(GPContextInpainting.inpaintingLayer.toCanvas(), 0, 0);
        GPContextInpainting.inpaintingLayer.opacity(0.5);

        GPContextInpainting.inpaintingLayer.opacity(1);
        let d1 = can.toDataURL('image/jpeg');
        GPContextInpainting.inpaintingLayer.opacity(0.5);
        let d2 = GP.project.backgroundCanvas.toDataURL('image/jpeg');

          let params = 'img='+encodeURIComponent(d2)+'&mask='+encodeURIComponent(d1);
          fetch('https://gardenpuzzle.com:8443/gpaux/inpaint', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: params
          }).then(async res => {
              if (!res.ok) {
                  throw new Error("HTTP error " + res.status);
              }
              GP.saveUndo("background", GP.project.backgroundCanvas.toDataURL('image/jpeg'));

              let data = await res.text();
              let bctx = GP.project.backgroundCanvas.getContext('2d');
              let img = new Image();
              img.onload = () => {
                  bctx.drawImage(img, 0, 0, GP.project.backgroundCanvas.width, GP.project.backgroundCanvas.height);
                  GPProjectView.backgroundLayer.draw();
                  magic.set(false);
                  GP.clearWaiting();
              }
              img.src = "data:image/jpeg;base64,"+data;
          }).catch(() => {magic.set(false); GP.clearWaiting();})
        //clear working area
        GPContextInpainting.inpaintingContext.clearRect(0,0,GP.project.sizeX, GP.project.sizeY);
        somethingDrawn.set(false);

    },

    handleKeyboard: function (e) {
        //Further actions only when project area active and applying textures
        if (($(".GPProjectView.active").length)) {
            var lastPos = {
                x: GPContextInpainting.inpaintingCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextInpainting.inpaintingCursorLastPos.y / GPProjectView.sceneScale
            };
            switch (e.which) {
                case 37: // left
                    GPContextInpainting.inpaintingCursorLastPos.x -= 5;
                    break;

                case 38: // up
                    GPContextInpainting.inpaintingCursorLastPos.y -= 5;
                    break;

                case 39: // right
                    GPContextInpainting.inpaintingCursorLastPos.x += 5;
                    break;

                case 40: // down
                    GPContextInpainting.inpaintingCursorLastPos.y += 5;
                    break;

                case 27: // esc
                    GP.restoreFocus();
                    break;

                default:
                    return; // exit this handler for other keys

                    e.preventDefault(); // prevent the default action (scroll / move caret)
            }
            var newPos = {
                x: GPContextInpainting.inpaintingCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextInpainting.inpaintingCursorLastPos.y / GPProjectView.sceneScale
            };
            GPContextInpainting.moveinpaintingCursor(GPContextInpainting.inpaintingCursorLastPos);
            if (e.shiftKey) GPContextInpainting.doCut(lastPos, newPos);
        }
    }

};

